<template>
  <div class="container">
    <div class="row">
      <div class="col jumbotron">
        <h1>Create new account</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-0 col-md-2 col-lg-3 col-xl-4"></div>
      <div class="col-12 col-md-8 col-lg-6 col-xl-4 px-5">
        <registration-form
          :broker-dealer-enabled="brokerDealerEnabled"
          :broker-dealer-label="brokerDealerLabel"
          :broker-dealers="brokerDealers"
          :global-error="error"
          :loading="loading"
          @register="onRegister"
        ></registration-form>
      </div>
      <div class="col-0 col-md-2 col-lg-3 col-xl-4"></div>
    </div>
  </div>
</template>

<script>
import RegistrationForm from '../components/register/RegistrationForm';
import {registerUser} from '../utility/api/open/registerUser';
import {formatErrorResponse} from '../utility/api/formatErrorResponse';
import {getQueryParamsMap} from '../utility/router/getQueryParamsMap';

export default {
  name: 'registration-page',
  components: {RegistrationForm},
  props: {
    brokerDealerEnabled: {
      type: Boolean,
    },
    brokerDealerLabel: {
      type: String,
    },
    brokerDealers: {
      type: Array,
    },
  },
  data() {
    const paramsMap = getQueryParamsMap();

    return {
      cart: paramsMap['c'],
      error: '',
      loading: false,
    };
  },
  methods: {
    async onRegister({email, password, passwordConfirmation, firstName, lastName, companyName, brokerDealerId}) {
      this.loading = true;

      try {
        await registerUser({
          email: email,
          password: password,
          password_confirmation: passwordConfirmation,
          first_name: firstName,
          last_name: lastName,
          company_name: companyName,
          broker_dealer_id: brokerDealerId,
          cart: this.cart
        });

        window.location.assign('/verify-email');
      } catch (error) {
        this.loading = false;
        this.error = error.response.data.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
